namespace GeniuzPOS.ReportMasterData {
    export interface Report_1318Row {
        Id?: string;
        PluCode?: string;
        PluDesc?: string;
        PluShortDesc?: string;
        DocDate?: string;
        ShopId?: string;
        ShopName?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        Qty?: number;
        GrossSales?: number;
        NetSales?: number;
        AllItemDiscount?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        FullName?: string;
        FullName1?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
    }

    export namespace Report_1318Row {
        export const idProperty = 'Id';
        export const nameProperty = 'PluCode';
        export const localTextPrefix = 'ReportMasterData.Report_1318';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PluShortDesc = "PluShortDesc",
            DocDate = "DocDate",
            ShopId = "ShopId",
            ShopName = "ShopName",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            Qty = "Qty",
            GrossSales = "GrossSales",
            NetSales = "NetSales",
            AllItemDiscount = "AllItemDiscount",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            FullName = "FullName",
            FullName1 = "FullName1",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name"
        }
    }
}
